export const defaultFacilityValues = {
  locale: 'en-GB',
  shortLocale: 'en',
  dateFormat: 'DD MMM, YYYY',
  timeFormat: 'hh:mm A'
}

export const initFacility = (facility: any) => {
    if (!facility) return

    if (facility.skinSettings == null) {
      facility.skinSettings = { backgroundImageUrl: null };
    }

    if (facility.skinSettings?.tiles == null) {
      facility.skinSettings.tiles = [];
    }

    facility.dateFormat = facility.dateFormat || defaultFacilityValues.dateFormat
    facility.timeFormat = facility.timeFormat || defaultFacilityValues.timeFormat
    facility.languageIso = facility.languageIso || defaultFacilityValues.locale

    return facility
}